import React from 'react'
import { useMediaQuery } from '@mui/material'
import MobileMenu from './mobile-menu'
import Menu from './menu'

const LanguageMenu = props => {
  const mobile = useMediaQuery(({ breakpoints }) => breakpoints.down('sm'))

  return mobile ? <MobileMenu {...props} /> : <Menu {...props} />
}

export default LanguageMenu
